import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraCouplesTherapySecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M29.6737 25.1102C32.0795 22.8303 34.4344 22.6002 36.4732 23.239C36.7925 20.3235 35.6589 17.4283 33.1714 16.0441C26.6726 12.4255 21.6172 19.3746 21.6172 19.3746C21.6172 19.3746 13.55 11.1681 8.15227 18.742C2.15157 27.1614 21.4507 40.4897 23.3106 40.07C24.5289 39.796 26.7759 37.8372 29.0861 35.288C27.3897 31.4611 26.9872 27.6562 29.6737 25.1117V25.1102Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M54.7378 27.3462C48.8019 22.2087 42.7688 28.3592 42.7688 28.3592C42.7688 28.3592 40.1394 24.3868 36.4736 23.239C36.3564 24.31 36.0479 25.3842 35.5297 26.3879C34.097 29.1594 31.557 32.5619 29.0864 35.288C32.1153 42.1212 39.2912 49.0312 40.5126 48.9999C43.0927 48.9341 51.3589 42.6802 55.0941 37.9577C57.6927 34.6726 57.6911 29.9031 54.7378 27.3462Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M36.4736 23.2393C34.4364 22.6004 32.0799 22.8321 29.6741 25.1104C26.9876 27.6564 27.3885 31.4598 29.0865 35.2867C31.5571 32.5606 34.0971 29.1581 35.5298 26.3866C36.048 25.3844 36.3564 24.3103 36.4736 23.2377V23.2393Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
